import React from 'react'
import connect from 'front-end-core/decorators/connect'
import { requestClarilisLink } from 'services/PrecedentsService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { ClarilisLinkSkeleton } from 'components/tiled-menu/PrecedentsTiledMenuSkeleton'

const ClarilisLink = ({ url, text }) => (
  <a
    className='flex justify-center items-center grow-1 h6 mv8 bg-white no-underline black f5 fw6 hover-underline hover-cadet-blue bb-thick b--precedents-blue pointer'
    href={url}
  >
    {text}
  </a>
)

export default connect(() => ({
  linkData: requestClarilisLink()
}))(({ linkData }) =>
  <ResponseConsumer
    response={linkData}
    content={() => <ClarilisLink {...linkData} />}
    pendingComponent={ClarilisLinkSkeleton}
    // don't render anything if the request fails
    baddataComponent={null}
    badresponseComponent={null}
    notfoundComponent={null}
  />
)
